const sitekey = process.env.REACT_APP_GOOGLE_RECAPTCHA;
// export const CAPTCHA_DEACTIVATED = process.env.NODE_ENV === "development";
export const CAPTCHA_DEACTIVATED = false;

export { sitekey };
